import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ThemeProvider,
  createTheme,
  styled,
} from '@mui/material';
import { isMobileOnly } from 'react-device-detect';
import BblButton from '../../../../component/buttons/bblButton';

const customTheme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#FFF3ED',
          borderRadius: '50px',
          padding: '24px 16px',
          height: isMobileOnly ? '70%' : '60%',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          textAlign: 'center',
          fontFamily: 'Poppins',
          fontStyle: 'normal',
          fontWeight: 600,
          fontSize: '22px',
          lineHeight: '36px',
          padding: '16px 0',
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          padding: 16,
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          justifyContent: 'center',
        },
      },
    },
  },
});

export const useTncDialog = () => {
  const [opened, setOpened] = useState(false);
  const openTnc = () => {
    setOpened(true);
  };
  const close = () => {
    setOpened(false);
  };

  return {
    openTnc,
    tncDialog: (
      <ThemeProvider theme={customTheme}>
        <Dialog open={opened} onClose={close} scroll={'paper'}>
          <DialogTitle id="scroll-dialog-title">
            Terms And Condition
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="scroll-dialog-description"
              tabIndex={-1}
              component={'span'}
              style={{
                fontFamily: 'Poppins',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: 15,
                lineHeight: '22px',
                letterSpacing: '0.0025em',
                color: '#000000',
              }}
            >
              {tncDiv}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <BblButton onClick={close} size={'medium'} color={'ghost'} mute>
              Close
            </BblButton>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    ),
  };
};

const title: React.CSSProperties = {
  fontWeight: 700,
};
const subtitle: React.CSSProperties = {
  textDecoration: 'underline',
};

const tncDiv = (
  <>
    <p style={title}>
      Project Alpha & Project Alpha Junior - Terms and Conditions
      <br />
      <br />
    </p>
    <p style={title}>1. Make-up class arrangement</p>
    <p style={subtitle}>Workshop and Community Networking Event</p>
    <p>
      There will be no make-up classes under any circumstances, including bad
      weather and students’ sickness.
    </p>
    <p style={subtitle}>
      Corporate Excursion, Science Fair and Graduation Ceremony
    </p>
    <p>
      If the excursion, science fair and graduation ceremony has to be canceled
      due to Red Rainstorm Signal, Black Rainstorm Signal, Typhoon Signal No. 8,
      No. 9 and No. 10, Big Bang Academy will attempt to accommodate a make-up
      session with no guarantee. The corporate excursion is subject to
      cancellation if the corporate has no availability to provide the make-up
      session. If students cannot attend the lessons at the given times, there
      will be no additional rescheduling or refund for the lessons.
    </p>
    <p style={title}> 2. Notice of change of class schedule</p>
    <p>
      Once a class schedule has been selected, it cannot be changed. If a change
      to the schedule is necessary, the student must provide Big Bang Academy
      with at least 7 days&apos; notice. Big Bang Academy reserves the right to
      charge an administrative fee of HKD $200 for any changes made to the
      schedule. It is the responsibility of the student to attend all sessions
      as scheduled, and any missed sessions will not be refunded or rescheduled.
    </p>
    <p style={title}>3. No refund policy</p>
    <p>
      Big Bang Academy operates under a strict no refund policy. Once payment
      for a program or service has been made, it is non-refundable under any
      circumstances.
    </p>
    <p style={title}>4.Bad weather arrangement</p>
    <p>
      If Red Rainstorm Signal, Black Rainstorm Signal, Typhoon Signal No. 8 or
      above is being hoisted two hours before the start of a class, all classes
      will be canceled. Big Bang Academy will make every effort to notify
      parents and students of the cancellation as soon as possible.
    </p>
    <p style={title}>5. Penalties for damage</p>
    <p>
      Parents are responsible for any damages caused by their child to the
      venues&apos; facilities. Big Bang Academy reserves the right to charge a
      penalty for any damages.
    </p>
    <p style={title}>6. No parents in workshops or excursions</p>
    <p>
      Parents are not allowed to accompany their child during workshops or
      excursions, except for community networking events and graduation ceremony
      & science fair.
    </p>
    <p style={title}>7. Punctuality</p>
    <p>
      Big Bang Academy requires all students to be punctual for their sessions.
      Late arrivals may cause disruptions and delay the start of the class for
      other students.
    </p>
    <p style={title}>8. Use of images and videos</p>
    <p>
      Big Bang Academy reserves the right to freely use all photography, film
      and sound material that has been created by Big Bang Academy and/or Big
      Bang Academy&apos;s staff during the program, without asking further
      approval from the participant. This includes any photos/recordings taken
      by parents/guardians which are sent to any staff member of Big Bang
      Academy. Big Bang Academy reserves all rights to images and footage.
    </p>
    <p style={title}>9. Right to make changes</p>
    <p>
      Big Bang Academy reserves the right to make changes to the schedule,
      curriculum, or policies at any time. Such changes will be communicated to
      parents as soon as possible.
    </p>
  </>
);
